<template>
  <v-card variant="outlined" class="pa-2" color="grey-lighten-2">
    <v-row density="comfortable">
      <v-col cols="12" sm="5" xl="4" align-self="center">
        <router-link :to="{ name: 'Product', params: { id: product.productId } }">
          <v-img
            :lazy-src="emptyPlaceholderImage"
            :src="product.imageUrl ? fitCropImage(product.imageUrl, 800, 800) : placeholderImage"
            :alt="product.title"
          />
        </router-link>
      </v-col>
      <v-col cols="12" sm="7" xl="8" class="d-flex flex-column">
        <sf-text ref="title" class="text-justify mb-1">
          {{ product.title }}
        </sf-text>
        <product-identifiers
          ref="identifiers"
          class="mb-5 text-high-emphasis"
          :article-number="product.articleNumber"
          :product-id="product.productId"
          large
        />
        <product-header-price
          class="text-high-emphasis"
          :product="product"
          :loading-realtime-prices="false"
          :add-to-cart-event="CtoEvent.AddToCart"
        />
      </v-col>
    </v-row>

    <v-row density="comfortable">
      <products-list-detail-sources
        v-if="product.suppliers.length > 0"
        :product-id="product.productId"
        :sources="product.suppliers"
        :loading-realtime-prices="false"
      />
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import { emptyPlaceholderImage, fitCropImage, placeholderImage } from '@/helpers'
import ProductHeaderPrice from '@/modules/product/components/ProductHeaderPrice.vue'
import ProductIdentifiers from '@/modules/product/components/ProductIdentifiers.vue'
import ProductsListDetailSources from '@/modules/product/components/ProductsListDetailSources.vue'
import CtoEvent from '@/modules/tracking/events/cto'
import { MediumProduct } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  product: {
    type: Object as PropType<MediumProduct>,
    required: true
  }
})
</script>
